import { render, staticRenderFns } from "./casino.vue?vue&type=template&id=1000c568&lang=pug&"
import script from "./casino.vue?vue&type=script&lang=js&"
export * from "./casino.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports